import { IndividualContactId, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountIndividualsQueryKey, accountQueryKey } from "../account.keys";

export const useAdminDeleteIndividualContact = (accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { _delete } = useRequest();

	const mutation = useMutation({
		mutationFn: async (individualContactId: IndividualContactId) => {
			await _delete(
				`/v2/admin/surety/accounts/${accountId}/individuals/${individualContactId}`,
				undefined,
				"none",
			);
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountIndividualsQueryKey(accountId) }),
			]);
		},
	});

	return {
		deleteIndividualContact: mutation.mutate,
		deleteIndividualContactError: mutation.error,
		deleteIndividualContactIsLoading: mutation.isPending,
		deleteIndividualContactSuccess: mutation.isSuccess,
	};
};
